import { Box, Button, Container, styled } from '@mui/material'
import zIndex from '@mui/material/styles/zIndex'
import bannerBg from 'img/drive-ai_signs.jpg'

export const StyledContainer = styled(Container)({
  padding: '40px 16px',
  minHeight: 'calc(100vh - 200px)',
  position: 'relative',
  ['@media (min-width: 1200px)']: {
    maxWidth: '1420px'
  }
})

export const StyledBanner = styled(Box)(({ theme }) => ({
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${bannerBg})`,
  marginBottom: '40px',
  borderRadius: '1em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: 'clamp(250px,20vw,300px)',
  position: 'relative',
  overflow: 'hidden',
  padding: '40px clamp(16px,5vw,50px)',
  boxShadow: '0px 6px 25px 0px rgba(7, 14, 49, 0.08)',
  ['&:before']: {
    content: '""',
    backgroundColor: '#4298FF',
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 2,
    opacity: '.4',
    mixBlendMode: 'initial'
  },
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    justifyContent: 'center'
  }
}))
